"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Parse = require("parse/node");
class CampaignBlacklist extends Parse.Object {
    constructor(attributes) {
        super('CampaignBlacklist', attributes);
    }
    /**
     *
     */
    get platform() { return this.get('platform'); }
    set platform(value) { this.set('platform', value); }
    /**
     * pode ser um telefone, email, etc
     */
    get destinationId() { return this.get('destinationId'); }
    set destinationId(value) { this.set('destinationId', value); }
    get retailer() { return this.get('retailer'); }
    set retailer(value) { this.set('retailer', value); }
}
exports.CampaignBlacklist = CampaignBlacklist;
Parse.Object.registerSubclass('CampaignBlacklist', CampaignBlacklist);
//# sourceMappingURL=CampaignBlacklist.js.map